import React from 'react';
import PropTypes from 'prop-types';

import {
  Space,
  Toggle,
  Text,
  Conditional,
  Popup,
} from '@cashfree-intl/coherent';
import { getModesIcons } from 'payments-icons-library';
import capitalize from 'lodash/capitalize';

import CustomIcon from 'components/CustomIcons';
import { StyledPaymentMethodIcon } from './styled';

import {
  ACTIVATED,
  AVAILABLE,
  REJECTED,
  DISABLED,
  STATUS_MAPPER,
  STATUS_COLOR_MAPPER,
  NOT_AVAILABLE,
  DISABLED_REASON,
  DISABLED_REASON_MAPPER,
  NOT_CONFIGURABLE_MESSAGE,
  NEGATIVE_MCC_CODES_FOR_UPI,
} from '../constants';

const UPI = ({ mcc, isTest, onToggle, data = {} }) => {
  const isNegativeMCC = NEGATIVE_MCC_CODES_FOR_UPI.includes(mcc);

  const [{ status, reason, isConfigurable }] = data.attributes;

  const isNotAvailable = status?.trim().toUpperCase() === NOT_AVAILABLE;

  return (
    <div className={`upi-payment-mode ${isNotAvailable ? 'blur' : ''}`}>
      <Space alignItems="center" gap={2}>
        {getModesIcons('upi', 'svg').map(icon => (
          <Popup
            content={capitalize(icon.icon_name)}
            trigger={
              <span className="pointer">
                <StyledPaymentMethodIcon
                  key={icon.icon_name}
                  className={icon.icon_name}
                  src={icon.icon_url}
                />
              </span>
            }
          />
        ))}
      </Space>
      <Conditional if={isNotAvailable}>
        <Text variant="b14" color="bodyLight">
          This payment mode is not applicable to you due to your merchant
          category.
        </Text>
      </Conditional>
      <Conditional if={!isNotAvailable}>
        <Text color="bodyLight">
          Payments via valid UPI apps are accepted. Customer can also pay using
          RuPay Credit Card, Prepaid Instruments and UPI Lite.
        </Text>
      </Conditional>
      <Space alignItems="center" gap={3}>
        <Conditional
          if={
            STATUS_COLOR_MAPPER[status] &&
            (!isTest || status?.trim().toUpperCase() === ACTIVATED)
          }
        >
          <Space alignItems="center">
            <Text color={STATUS_COLOR_MAPPER[status]}>
              {STATUS_MAPPER[status]}
            </Text>
            <Conditional if={[REJECTED, DISABLED].includes(status)}>
              <Popup
                content={DISABLED_REASON.replace(
                  '$reason$',
                  `${DISABLED_REASON_MAPPER[reason?.toUpperCase()] || ''}`,
                )}
                trigger={
                  <span className="info pointer reason ml-1">
                    <CustomIcon componentName="INFO" />
                  </span>
                }
                position="top right"
              />
            </Conditional>
          </Space>
        </Conditional>
        <Conditional if={!isTest}>
          {/* for DISABLED, REJECTED, IN_REVIEW -> opacity and disable the toggle */}
          {/* AVAILABLE and ACTIVATED ->  */}
          <Conditional if={isConfigurable}>
            <div>
              <Toggle
                disabled={status !== AVAILABLE || isNegativeMCC}
                active={status === ACTIVATED}
                onToggle={onToggle(data.attributes[0])}
                data-event-name="Form_UPI_Toggle"
                data-ignore-inner-text="true"
              />
            </div>
          </Conditional>
          <Conditional if={!isConfigurable}>
            <Popup
              content={NOT_CONFIGURABLE_MESSAGE}
              trigger={
                <div>
                  <Toggle
                    disabled
                    active={status === ACTIVATED}
                    onToggle={onToggle(data.attributes[0])}
                    data-event-name="Form_UPI_Toggle"
                    data-ignore-inner-text="true"
                  />
                </div>
              }
              position="top right"
            />
          </Conditional>
        </Conditional>
      </Space>
    </div>
  );
};

UPI.propTypes = {
  data: PropTypes.object.isRequired,
  isTest: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  mcc: PropTypes.number.isRequired,
};

export default UPI;
